(function () {
  'use strict';
  var REGION_CODES = ('AF AX AL DZ AS AD AO AI AQ AG AR AM AW AU AT AZ BS BH BD BB BY BE BZ BJ BM BT BO BQ BA BW BV BR IO BN BG BF BI CV KH CM CA KY CF TD CL CN CX CC CO KM CG CD CK CR CI HR CU CW CY CZ DK DJ DM DO EC EG SV GQ ER EE SZ ET FK FO FJ FI FR GF PF TF GA GM GE DE GH GI GR GL GD GP GU GT GG GN GW GY HT HM VA HN HK HU IS IN ID IR IQ IE IM IL IT JM JP JE JO KZ KE KI KP KR KW KG LA LV LB LS LR LY LI LT LU MO MG MW MY MV ML MT MH MQ MR MU YT MX FM MD MC MN ME MS MA MZ MM NA NR NP NL NC NZ NI NE NG NU NF MK MP NO OM PK PW PS PA PG PY PE PH PN PL PT PR QA RE RO RU RW BL SH KN LC MF PM VC WS SM ST SA SN RS SC SL SG SX SK SI SB SO ZA GS SS ES LK SD SR SJ SE CH SY TW TJ TZ TH TL TG TK TO TT TN TR TM TC TV UG UA AE GB UM US UY UZ VU VE VN VG VI WF EH YE ZM ZW').split(' ');
  function buildCountryOptions(select) {
    if (!select || select.dataset.pmGlobalCountries === 'true') return;
    var displayNames = null;
    try { if (window.Intl && Intl.DisplayNames) displayNames = new Intl.DisplayNames(['en'], { type: 'region' }); } catch (_e) {}
    if (!displayNames) return;
    var currentValue = select.value || '';
    var countries = REGION_CODES.map(function (code) {
      return { code: code, name: displayNames.of(code) || code };
    }).filter(function (item) { return item.name && item.name !== item.code; })
      .sort(function (a, b) { return a.name.localeCompare(b.name, 'en'); });
    if (!countries.length) return;
    select.textContent = '';
    var placeholder = document.createElement('option');
    placeholder.value = ''; placeholder.textContent = 'Select country / region';
    placeholder.disabled = true; placeholder.selected = !currentValue; select.appendChild(placeholder);
    countries.forEach(function (item) {
      var option = document.createElement('option'); option.value = item.name; option.textContent = item.name;
      if (currentValue && currentValue === item.name) option.selected = true;
      select.appendChild(option);
    });
    select.dataset.pmGlobalCountries = 'true';
  }
  function applyP0FormFixes() {
    buildCountryOptions(document.getElementById('pm-country'));
    var dthOption = document.querySelector('#ProductInterestOptions option[value="DTH Tools"]');
    if (dthOption) dthOption.remove();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyP0FormFixes);
  else applyP0FormFixes();
})();
